import { useMutation, useQuery } from '@tanstack/react-query'
import type { ResolvedBadge, VirtualBadgeToken } from '@/types'
import { getMyBadgeToken, resolveBadge } from '../services/virtual-badge'

const MY_TOKEN_QUERY_KEY = ['virtual-badge', 'me', 'token']

// Renova o QR alguns minutos antes de expirar, para nunca exibir um código vencido
const RENEW_BEFORE_EXPIRY_MS = 5 * 60 * 1000
const MIN_REFETCH_INTERVAL_MS = 30 * 1000

export function useMyBadgeToken(enabled: boolean) {
	return useQuery<VirtualBadgeToken, Error>({
		queryKey: MY_TOKEN_QUERY_KEY,
		queryFn: getMyBadgeToken,
		enabled,
		// Token nunca é reaproveitado do cache: cada abertura gera um novo
		staleTime: 0,
		gcTime: 0,
		refetchOnWindowFocus: true,
		refetchInterval: (query) => {
			const expiresAt = query.state.data?.expiresAt
			if (!expiresAt) return false
			const msUntilRenew =
				new Date(expiresAt).getTime() - Date.now() - RENEW_BEFORE_EXPIRY_MS
			return Math.max(msUntilRenew, MIN_REFETCH_INTERVAL_MS)
		},
	})
}

export function useResolveBadge() {
	return useMutation<ResolvedBadge, Error, string>({
		mutationFn: resolveBadge,
	})
}
